import { gql } from '@/shared/types/gql';

/**
 * Fallback used by AuthProvider when a session exists but no user is stored
 * locally. It must mirror what `POST /api/login` puts in `JWTPayload.user`,
 * because both feed the same `toUser` mapper.
 *
 * Keep every field below present on the `User` type — one unknown field fails
 * the whole operation, and this query is the only way back to a usable session
 * when localStorage is empty.
 */
export const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    me {
      id
      username
      email
      firstName
      lastName
      avatar
      preferredLanguage
      roles
      theme
    }
  }
`;
